<template lang="html">
  <div class="">
    <header class="Lokallag-header">
     <div class="Lokallag-header-image" v-if="data.chapterHeaderImage" :style="{backgroundImage: 'url('+data.chapterHeaderImage.image.asset.url+'?w=3000&h=700)'}">
     </div>
    </header>
    <nav class="Lokallag-navigation">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-10 is-offset-1 has-text-centered">
            <div style="margin-bottom: 0" class="content">
              <h2 class="Lokallag-heading">{{data.title}}</h2>
            </div>
            <!-- <div class="column is-12">
              <div class="Tabs tabs is-medium is-centered">
                <ul class="Tabs-menu">
                  <li class="Tabs-menuItem">class=('is-active' if current_page.url.include? 'program')<a href="/undefined/program" class="Tabs-menuLink">Vår politikk</a></li>
                  <li class="Tabs-menuItem">class=('is-active' if current_page.url.include? 'folk')<a href="/undefined/folk" class="Tabs-menuLink">Våre folk</a></li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </nav>
    <div class="columns">
      <div class="column is-12 is-4-desktop is-offset-1-desktop" v-if="articles.length > 0">
        <section class="ArticleList" style="padding-top:0;">
          <h3 class="title sectionHeading">Siste nytt</h3>
          <div class="ArticleList-item" v-for="article in articles">
            <router-link :to="data.slug.current + article.slug.current">
              <image-source
                v-if="article.thumbnail"
                :hotspot="article.thumbnail.asset.hotspot"
                :crop="article.thumbnail.asset.crop"
                :metadata="article.thumbnail.asset.metadata"
                :source="article.thumbnail.asset.url"
                :widths="widths" :ratio=1.78 :alt="article.title" >
              </image-source>
            </router-link>
            <h4 class="title ArticleList-title" style="margin-bottom: 0; display: inline;">
              <router-link :to="data.slug.current + '/' + article.slug.current" style="margin-bottom: 0;">{{article.title}}</router-link>
            </h4>
            <p class="is-font-sans" style="margin-bottom: 44px;">{{article.lead}}</p>
          </div>
        </section>
      </div>
		<!-- - unless articles.empty?
				.column.is-12.is-5-desktop
					section.ArticleList style="padding-top: 0;"
						h3.title.sectionHeading Siste nyheter
						- articles.each do |article|
							- unless article.publishedAt.nil?
								- publishDateTime = article.publishedAt.local
							- else
								- publishDateTime = article._createdAt
							.ArticleList-item
								- unless article['thumbnail'].nil?
									a.ArticleList-imageContainer href="/#{slug}/#{article['slug']['current']}"
										= img_srcset_helper(article['thumbnail']['asset']['url'], [600, 800, 1200], 1.78, article['title'])
										.ArticleList-imageHover

								h4.title.ArticleList-title style="margin-bottom: 0; display: inline;"
									a href="/#{slug}/#{article.slug.current}" style="margin-bottom: 0;"
										= article.title
								p.Article-metadata(style="margin-bottom: 11px;")
									= I18n.localize(DateTime.parse(publishDateTime), :format => "%d. %B %Y %H:%M")

								p.is-font-sans style="margin-bottom: 44px;" = article.lead
					.content
						a.is-font-sans href="/#{slug}/arkiv" Se flere i arkivet         -->
      </section>
      <div class="column is-12 is-5-desktop is-offset-1-desktop" v-if="data.contact">
        <section class="Lokallag-contact">
          <table>
            <tr>
              <td>
                <p><strong>Leder</strong></p>
              </td>
              <td>
                <person-card :person="data.contact.leader"></person-card>
              </td>
            </tr>
            <tr v-if="data.contact.email">
              <td>
                <p><strong>E-post</strong></p>
              </td>
              <td>
                <p>
                  <a :href="data.contact.email" class="is-font-mono">{{data.contact.email}}</a>
                </p>
              </td>
            </tr>
            <tr v-if="data.contact.address">
              <td>
                <p><strong>Adresse</strong></p>
              </td>
              <td>
                <p>
                  <p class="is-font-mono" style="white-space: pre;">{{data.contact.address}}</p>
                </p>
              </td>
            </tr>
            <tr v-if="chapters.length > 0">
              <td>
                <p><strong>Lokallag</strong></p>
              </td>
              <td>
                <form class="Form">
                  <span class="select">
                    <select class="" name="" v-model="selected">
                      <option disabled selected>Velg lokallag</option>
                      <option v-for="chapter in chapters" :value="chapter.slug.current">
                        {{chapter.title}}
                      </option>
                    </select>
                  </span>
                </form>
              </td>
            </tr>
          </table>
          <div v-if="data.contact.external_site">
            <div class="Button is-Facebook" type="button" @click="this.open(data.contact.external_site)" v-if="data.contact.external_site.indexOf('facebook') > -1">
              <icon name="facebook-official"></icon> Finn oss på Facebook
            </div>
            <div class="Button" type="button" @click="this.open(data.contact.external_site)" v-else-if="data.contact.external_site">
              Besøk nettsiden vår
            </div>
          </div>

        </section>
      </div>
    </div>
  </div>
</template>

<script>
import PersonCard from '@/components/PersonCard'
import sanityQuery from '@/sanityQuery'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/facebook-official'
import NewsList from '@/components/NewsList'
import ImageSource from '@/components/ImageSource'

export default {
  components: {
    'person-card': PersonCard,
    Icon,
    NewsList,
    ImageSource
  },
  props: ['data'],
  data () {
    return {
      chapters: [],
      selected: 'Velg lokallag',
      articles: [],
      widths: [600, 800, 1200]
    }
  },
  watch: {
    selected: function (selected) {
      this.$router.push({path: selected})
    },
    // Watch for changes in the props sent to the component.
    // Reload data if new component data (new chapter loaded), or else we get stuck with the previous data.
    data: function () {
      this.getLocalChapters()
    }
  },
  created () {
    this.getLocalChapters()
  },
  methods: {
    getLocalChapters () {
      var query = `*[_type == "lag" && references("${this.data._id}") && !(_id in path "drafts.**")] | order(title asc) [0...200]{title, slug}`
      sanityQuery(query)
        .then(result => {
          this.chapters = result
        })
    }
  }
}
</script>

<style lang="sass">
  @import '../assets/stylesheets/_variables.sass'

  .Lokallag-header
    background-color: lighten($blackish, 70%)
</style>



// WEBPACK FOOTER //
// src/pages/Chapter.vue